import { Grid, Box } from "@mui/material"
import { DataGrid } from '@mui/x-data-grid'
import { withStyles } from '@material-ui/core/styles'
import { format } from 'date-fns'

import styles from './campaignStyle'

const SocialAd = ({ classes, campaignList, campaignInfo, visitorsInfo}) => {

    const columnOne = [
        {
            field: 'date_time',
            headerName: 'Date & Time',
            width: 150,
            valueFormatter: (params) => {
                return format(new Date(params), 'yyyy-MM-dd HH:mm');
            }
        },
        {
            field: 'phone_email',
            headerName: 'Phone / Email',
            width: 180,
        },

        {
            field: 'campaign_link',
            headerName: 'Referral Code',
            width: 120,
            valueGetter: (params) => {          
                const parts = params.split(' ')
                // Return the last part if it exists and is not just empty
                return parts.length > 1 ? parts[parts.length - 1] : ''
            },
            align: 'center'
        },
    ]

    const columnTwo = [
        {
            field: 'date',
            headerName: 'Date',
            width: 90,
        },
        {
            field: 'total_phone_count',
            headerName: 'Total Phone',
            width: 100,
            align: 'center'
        },
        {
            field: 'unique_phone_count',
            headerName: 'Unique Phone',
            width: 120,
            align: 'center'
        },
        {
            field: 'unique_ip_count',
            headerName: 'Users',
            width: 80,
            align: 'center'
        },
        {
            field: 'ad_campaign',
            headerName: 'Total Count',
            width: 100,
            align: 'center'
        },
        {
            field: 'unique_ad_campaign',
            headerName: 'Unique Count',
            width: 120,
            align: 'center'
        }
    ]
    // code correction by Srini - 27-10-25
    const updatedCampaignInfo = visitorsInfo.map(visitor => {
        const matchingCampaign = campaignInfo.find(campaign => campaign.date === visitor.date)
    
        if (matchingCampaign) {
            // Merge data from both visitorsInfo and campaignInfo
            return {
                ...visitor,
                ...matchingCampaign
            }
        }
    
        // If no matching campaign record is found return only visitorsInfo data
        return {
            ...visitor,
            // Placeholder or default value
            total_phone_count: 0, 
            unique_phone_count: 0,
            unique_ip_count: 0
        }
    })

    return (
        <Grid
            mt='1%'
            container spacing={2}
        >
            <Grid item xs={6}
            >
                <Box
                    className={classes.horizantalTablayout}
                >
                    <DataGrid
                        className={classes.customDataGrid}

                        rows={campaignList}
                        columns={columnOne} // Srini - 24/12/24
                        getRowId={(row) => row?.c_id ?? Math.random().toString(36).substr(2, 9)}
                        sx={{
                            '--DataGrid-containerBackground': '#131E2E',
                            '--DataGrid-rowBorderColor': '#000',
                            'border': 0,
                        }}

                        initialState={{
                            pagination: {
                                paginationModel: { page: 0, pageSize: 10 },
                            },
                        }}

                        pageSizeOptions={[10, 25, 50]} // Srini - 12/11/24
                    />
                </Box>
            </Grid>
            <Grid item xs={6}
            >
                <Box
                    className={classes.horizantalTablayout}
                >
                    <DataGrid
                        className={classes.customDataGrid}
                        rows={updatedCampaignInfo}
                        columns={columnTwo}
                        getRowId={(row) => row?.date ?? Math.random().toString(36).substr(2, 9)}

                        sx={{
                            '--DataGrid-containerBackground': '#131E2E',
                            '--DataGrid-rowBorderColor': '#000',
                            'border': 0,
                        }}

                        initialState={{
                            pagination: {
                                paginationModel: { page: 0, pageSize: 10 },
                            },
                        }}

                        pageSizeOptions={[10, 25, 50]}
                    />
                </Box>
            </Grid>
        </Grid>
    )
}

export default withStyles(styles)(SocialAd)